import {slide} from "../../library/slide";
import {ajax} from "../../library/ajax";
import {modal} from "./modal";

document.getElementById('contactType').addEventListener('change', selectContactType);
document.getElementById('file').addEventListener('change', uploadImage);
document.getElementById('sendContact').addEventListener('click', sendContact);

function sendContact() {
    let contactType = document.getElementById('contactType');
    ajax.post(
        '/ajax/contact/send',
        {
            type: contactType.options[contactType.selectedIndex].value,
            typeText: contactType.options[contactType.selectedIndex].text,
            reference: document.getElementById('orderReference').value,
            observations: document.getElementById('observations').value,
            reason: document.getElementById('reason').value,
            file: document.getElementById('uploadedFile').value,
            doubts: document.getElementById('doubts').value,
            name: document.getElementById('name').value,
            email: document.getElementById('email').value,
            phone: document.getElementById('phone').value,
            consentPhone: document.getElementById('consent').checked,
            privacy: document.getElementById('privacy').checked,
        },
        function() {
            let successModal = document.getElementById('successModal');
            modal.show(successModal);
        },
        function(data) {
            document.getElementById('error-text').innerHTML = data.message;
            let errorModal = document.getElementById('errorModal');
            modal.show(errorModal);
        }
    )
}

function uploadImage() {
    let file = document.getElementById('file').files[0];
    ajax.uploadImage(
        file,
        function(data) {
            let fileInfo = data.fileInfo;

            let container = document.getElementById('uploaded-file');
            container.innerHTML = '';
            document.getElementById('uploadedFile').value = fileInfo.file;

            let content = document.createElement('span');
            content.innerHTML = fileInfo.originalName;
            container.append(content);

            slide.down(container);
        }
    );
}

function selectContactType() {
    let contactType = document.getElementById('contactType');
    let value = contactType.options[contactType.selectedIndex].value;
    let selectedClass = null;
    if (value) {
        selectedClass = value+'-data';
    }

    let contactData = document.getElementsByClassName('contact-data');
    for (let i = 0; i < contactData.length; i++) {
        if (!selectedClass || !contactData[i].classList.contains(selectedClass)) {
            slide.up(contactData[i]);
        }
    }
    if (selectedClass) {
        let selectedContactData = document.getElementsByClassName(selectedClass);
        for (let i = 0; i < selectedContactData.length; i++) {
            slide.down(selectedContactData[i]);
        }
    }
}